import { config } from './core/config'

//-------------------------------------------------------------------
if (config.debugging) {
  console.debug = console.debug.bind(console, '%c[debug]', 'color:#00BC7E; line-height:14px;')
} else {
  console.debug = function () {}
}

//-------------------------------------------------------------------
console.debug('config.json', config)

//-------------------------------------------------------------------
// fix prevent draggable
//window.ondragstart = () => false

//-------------------------------------------------------------------
// if ('storage' in navigator && 'estimate' in navigator.storage) {
//   navigator.storage.estimate().then(({usage, quota}) => {
//     console.log(`Using ${usage} out of ${quota} bytes.`);
//   }).catch(error => {
//     console.error('Loading storage estimate failed:');
//     console.log(error.stack);
//   });
// } else {
//   console.error('navigator.storage.estimate API unavailable.');
// }